export default __webpack_public_path__ + "static/media/linkedin.f85b22c3.jpg";